
import { h, Fragment } from 'preact'; /** @jsx h */
import { useEffect, useState } from 'preact/hooks';
import { useLocation } from 'preact-iso';

import { ROUTES } from "@pyqml/shared";

import { Layout } from '../components/Layout';
import { SubscribeTeaser } from '../components/SubscribeTeaser';

import { useAuth } from '../app/AuthProvider';



const OtpModal = ({onClose, email}) => {
    
    //const { cacheableQuery, cacheablePromise } = useCacheableQueryProvider();
    const { onLogin } = useAuth();
	const [otp, setOtp] = useState("");

	
    useEffect(() => {

		
        const handleClickOutside = (event: MouseEvent) => {
            const modal = document.querySelector('.modal-dialog');
            if (modal && !modal.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (

        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ overflowY: "auto", maxHeight: "calc(100vh - 210px)" }}>
                <div className={`modal-header border-0 bg-primary`}>
                    <h5 className="font-weight-bold" style={{ marginBottom: 0, fontFamily: "ShadowsIntoLight"}}>Enter your OTP</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => onClose()}>
                    <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="pb-4 pr-4 pl-4 text-center">
						We have sent an one-time password to your e-mail address. Please enter it here.
						<div className="col-md-12">
							<div className="row">
								<div className="col-md-8">
									<input
										type="text"
										className="form-control"
										placeholder="Enter your OTP"
										value={otp}
										onInput={e => setOtp(e.target.value)}
									></input>
								</div>
								<div className="col-md-4">
									<button
										type="submit"
										className="btn btn-success btn-block"
										onClick={()=>onLogin({email, otp}, (success: boolean, responseData: any) => {
											console.log("signupResponse", success, responseData);
											if (success) {
												onClose(true);
											}
											return true;
										
										})}
									>
										Submit
									</button>
									
								</div>
							</div>
						</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const Login = (props) => {

	const [email, setEmail] = useState("");
	const [showModal, setShowModal] = useState<boolean>(false);

	const location = useLocation();

	const { onLogin, onSignUp, token } = useAuth();
    
	const session_id = location.query?.[ROUTES.QUERY_BLOG_SESSIONID];
	const [loading, setLoading] = useState<boolean>(false);
	
	


	//console.log("session_id", location.query, session_id, loading);

	useEffect(() => {
		// the user is already logged in
		if (token) {
			location.route(ROUTES.BLOG_HOME);
		} else if (session_id) {
			// we have a session ID from the checkout
			setLoading(true);
			onLogin({session_id},  (success: boolean, responseData: any) => {
				console.log("loginResponse", success, responseData);
				
				if (!success) {
					setLoading(false);
				} else {
					location.route(ROUTES.BLOG_HOME);
				}
				return false;
			});
		} else {
			// get url query params
			const urlParams = new URLSearchParams(window.location.search);
			const queryEmail = urlParams.get("email");
			const queryOtp = urlParams.get("otp");
			if (queryEmail && queryOtp) {
				onLogin({email: queryEmail, otp: queryOtp}, (success: boolean, responseData: any) => {
					console.log("signupResponse", success, responseData);
					return true;
				
				})
			}
			console.log("urlParams", urlParams.get("email"));
		}
	}, [session_id]);


    return <Fragment>
		{ showModal &&
            <div
                style={{
                    position: "fixed",
                    color: "white",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 1000
                    }}>
                <OtpModal onClose={()=>setShowModal(false)} email={email}/>
            </div>        
        }
		<Layout.Stacked>
			<Layout.Section weight="full">
				
				<h1 className="display-4 secondfont mb-3 font-weight-bold" style={{ marginTop: "1rem"}}>Sign In</h1>
				<p>Please enter your credentials to login.</p>
				<div className="col-md-12">
					<div className="row">
						<div className="col-md-8">
							<input
								type="text"
								className="form-control"
								placeholder="Enter your e-mail address"
								value={email}
								onInput={e => setEmail(e.target.value)}
							></input>
						</div>
						<div className="col-md-4">
							{ loading ? "Please wait" : <button
								type="submit"
								className="btn btn-success btn-block"
								disabled={
									!(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(email)) || loading
								}
								onClick={()=> {
									setLoading(true);
									onSignUp({email}, (success: boolean, responseData: any) => {
										console.log("signupResponse", success, responseData);
										if (success) {
											setShowModal(true);
										}
										setLoading(false);
										return true;
									
									})
								}}
							>
								Sign in
							</button>
							}
						</div>
					</div>
				</div>
				<hr/>
				<SubscribeTeaser />
			</Layout.Section>

		</Layout.Stacked>
	</Fragment>
}
  